import React from "react";

import User from "./user";
import Admin from "./admin";

import useStore from "../../store";

const Dashboard = () => {
  const { user } = useStore();

  if (user.role === "admin") return <Admin />;
  return <User />;
};

export default Dashboard;
